/**
 * Judge.me – Make ALL reviews verified + fix pagination
 *
 * 1. Sets data-verified-buyer="true" + badge markup on reviews missing it
 * 2. Shows ALL page numbers in pagination (Judge.me only renders ~3)
 */
(function () {
  'use strict';

  /* ── VERIFIED BADGE PATCHING ── */

  function patchReview(rev) {
    // Skip if already verified with badge
    var alreadyVerified = rev.getAttribute('data-verified-buyer') === 'true';
    var hasBadge = rev.querySelector('.jdgm-rev__buyer-badge-wrapper');

    if (alreadyVerified && hasBadge) return; // already good, don't touch

    // Set the attribute
    if (!alreadyVerified) {
      rev.setAttribute('data-verified-buyer', 'true');
    }

    // Add badge markup only if missing
    if (!hasBadge) {
      var authorWrapper = rev.querySelector('.jdgm-rev__author-wrapper');
      if (!authorWrapper) return;

      var badgeWrapper = document.createElement('span');
      badgeWrapper.className = 'jdgm-rev__buyer-badge-wrapper';
      var badge = document.createElement('span');
      badge.className = 'jdgm-rev__buyer-badge';
      badgeWrapper.appendChild(badge);
      authorWrapper.appendChild(badgeWrapper);
    }
  }

  function patchAllReviews() {
    document.querySelectorAll('.jdgm-rev').forEach(patchReview);
  }

  /* ── PAGINATION FIX ── */

  var storedPerPage = 0; // locked after first full page load

  function getTotalReviews(widget) {
    // Parse "Based on X reviews" from the summary text
    var summary = widget.querySelector('.jdgm-rev-widg__summary-text');
    if (summary) {
      var match = summary.textContent.match(/(\d+)\s*(reviews?|Bewertung)/i);
      if (match) return parseInt(match[1], 10);
    }
    // Fallback: check the preview badge
    var badge = document.querySelector('.jdgm-prev-badge__text');
    if (badge) {
      var m = badge.textContent.match(/(\d+)/);
      if (m) return parseInt(m[1], 10);
    }
    return 0;
  }

  function getReviewsPerPage(widget) {
    // Only measure on first call (page 1 is always full)
    // After that, reuse the stored value so the last page
    // (with fewer reviews) doesn't mess up the calculation
    if (storedPerPage > 0) return storedPerPage;

    var revs = widget.querySelectorAll('.jdgm-rev-widg__reviews .jdgm-rev');
    var count = revs.length || 5;
    storedPerPage = count;
    return count;
  }

  function fixPagination() {
    var widget = document.getElementById('judgeme_product_reviews');
    if (!widget) return;
    /* Skip if widget is inside combined-reviews hidden host */
    if (widget.closest('[id^="cr-jdgm-host"]')) return;

    var paginate = widget.querySelector('.jdgm-paginate');
    if (!paginate) return;

    var totalReviews = getTotalReviews(widget);
    var perPage = getReviewsPerPage(widget);
    if (totalReviews === 0 || perPage === 0) return;

    var totalPages = Math.ceil(totalReviews / perPage);
    if (totalPages <= 1) return;

    // Find current page
    var currentLink = paginate.querySelector('.jdgm-curt');
    var currentPage = currentLink ? parseInt(currentLink.textContent.trim(), 10) : 1;

    // Find existing page links
    var existingPages = {};
    paginate.querySelectorAll('.jdgm-paginate__page').forEach(function (link) {
      var num = parseInt(link.textContent.trim(), 10);
      if (!isNaN(num)) existingPages[num] = link;
    });

    // Find a reference link to clone
    var refLink = existingPages[Object.keys(existingPages)[0]];
    if (!refLink) return;

    // Find insertion point (before next button)
    var nextBtn = paginate.querySelector('.jdgm-paginate__next-page');

    // Create missing page links
    for (var p = 1; p <= totalPages; p++) {
      if (existingPages[p]) continue; // already exists

      var newLink = refLink.cloneNode(true);
      newLink.textContent = p;
      newLink.classList.remove('jdgm-curt');
      newLink.setAttribute('data-page', p);

      // Add click handler
      (function (pageNum) {
        newLink.addEventListener('click', function (e) {
          e.preventDefault();
          navigateToPage(widget, pageNum);
        });
      })(p);

      // Insert in correct order — find the right position
      var inserted = false;
      var allLinks = paginate.querySelectorAll('.jdgm-paginate__page');
      for (var i = 0; i < allLinks.length; i++) {
        var linkNum = parseInt(allLinks[i].textContent.trim(), 10);
        if (linkNum > p) {
          paginate.insertBefore(newLink, allLinks[i]);
          inserted = true;
          break;
        }
      }
      if (!inserted) {
        if (nextBtn) {
          paginate.insertBefore(newLink, nextBtn);
        } else {
          paginate.appendChild(newLink);
        }
      }
    }
  }

  function navigateToPage(widget, targetPage) {
    /* Skip if widget is inside combined-reviews hidden host */
    if (widget.closest('[id^="cr-jdgm-host"]')) return;
    var paginate = widget.querySelector('.jdgm-paginate');
    if (!paginate) return;

    // If there's an existing link for this page, click it
    var existingLink = null;
    paginate.querySelectorAll('.jdgm-paginate__page').forEach(function (link) {
      if (parseInt(link.textContent.trim(), 10) === targetPage) {
        existingLink = link;
      }
    });

    // Find current page
    var currentLink = paginate.querySelector('.jdgm-curt');
    var currentPage = currentLink ? parseInt(currentLink.textContent.trim(), 10) : 1;
    if (targetPage === currentPage) return;

    // Navigate using next/prev clicks
    var direction = targetPage > currentPage ? 'next' : 'prev';
    var steps = Math.abs(targetPage - currentPage);
    var btnClass = direction === 'next' ? '.jdgm-paginate__next-page' : '.jdgm-paginate__prev-page';

    function clickStep(remaining) {
      if (remaining <= 0) return;
      var btn = paginate.querySelector(btnClass + ':not(.jdgm-disabled)');
      if (!btn) return;
      btn.click();
      setTimeout(function () { clickStep(remaining - 1); }, 350);
    }

    clickStep(steps);
  }

  /* ── MUTATION OBSERVER ── */

  var paginationDebounce = null;

  var observer = new MutationObserver(function (mutations) {
    var needsPatch = false;

    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var node = added[j];
        if (node.nodeType !== 1) continue;

        if (node.classList && node.classList.contains('jdgm-rev')) {
          patchReview(node);
          needsPatch = true;
        }

        if (node.querySelectorAll) {
          node.querySelectorAll('.jdgm-rev').forEach(function (r) {
            patchReview(r);
            needsPatch = true;
          });
        }
      }
    }

    if (needsPatch) {
      clearTimeout(paginationDebounce);
      paginationDebounce = setTimeout(fixPagination, 200);
    }
  });

  if (document.body) {
    observer.observe(document.body, { childList: true, subtree: true });
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      observer.observe(document.body, { childList: true, subtree: true });
      patchAllReviews();
      setTimeout(fixPagination, 500);
    });
  }

  if (document.readyState !== 'loading') {
    patchAllReviews();
    setTimeout(fixPagination, 1000);
    setTimeout(fixPagination, 2500);
  }
})();
